import React from "react";
import styled from "styled-components";
import { Button, Col, Row } from "components/common";
import { useHistory } from "react-router";
import { removeStorage } from "utils/auth";
import { getUserPermissions } from "utils/text";

const HomePageForm = () => {
  const history = useHistory();
  return (
    <div>
      <Wrapper>
        <div className="form-container">
          <div>
            <Row gutter={[15, 15]}>
              <Col xs={24} sm={24} lg={12} xl={12} xxl={12}>
                <a href="javascript:void(0)">
                  <Button
                    title="LEAD FORM"
                    onClick={() => {
                      history.push("/lead-form");
                    }}
                  />
                </a>
              </Col>
              {getUserPermissions("ViewLeads") && (
                <Col xs={24} sm={24} lg={12} xl={12} xxl={12}>
                  <a href="javascript:void(0)">
                    <Button
                      title="LEAD LIST"
                      onClick={() => {
                        history.push("/leads?offset=0&limit=10");
                      }}
                    />
                  </a>
                </Col>
              )}

              <Col xs={24} sm={24} lg={12} xl={12} xxl={12}>
                <a href="javascript:void(0)">
                  <Button
                    title="PAYMENTS"
                    onClick={() => {
                      history.push("/payments");
                    }}
                  />
                </a>
              </Col>
              <Col xs={24} sm={24} lg={12} xl={12} xxl={12}>
                <a href="javascript:void(0)">
                  {" "}
                  <Button
                    title="EXPENSES"
                    onClick={() => {
                      history.push("/expenses");
                    }}
                  />
                </a>
              </Col>
              <Col
                xs={24}
                sm={24}
                lg={getUserPermissions("ViewUsers") ? 12 : 24}
                xl={getUserPermissions("ViewUsers") ? 12 : 24}
                xxl={getUserPermissions("ViewUsers") ? 12 : 24}
              >
                <a href="javascript:void(0)">
                  <Button
                    title="PROJECTS"
                    onClick={() => {
                      history.push("/projects");
                    }}
                  />
                </a>
              </Col>
              {getUserPermissions("ViewUsers") && (
                <Col xs={24} sm={24} lg={12} xl={12} xxl={12}>
                  <a href="javascript:void(0)">
                    <Button
                      title="USERS"
                      onClick={() => {
                        history.push("/users?offset=0&limit=10&active=true");
                      }}
                    />
                  </a>
                </Col>
              )}
            </Row>
          </div>
        </div>
      </Wrapper>
      <Wrapper>
        <div className="form-container">
          <div>
            <Row gutter={[15, 15]}>
              <Col xs={24}>
                <a href="javascript:void(0)">
                  <Button
                    title="Logout"
                    onClick={() => {
                      removeStorage();
                      history.push(`/login`);
                    }}
                  />
                </a>
              </Col>
            </Row>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default HomePageForm;

const Wrapper = styled.div`
  margin-bottom: 20px;
  .form-container {
    background: #131f28;
    width: 450px;
    border: 0 none;
    border-radius: 20px;
    box-shadow: 0 0 15px 1px rgb(0 0 0 / 40%);
    padding: 30px 40px;
    box-sizing: border-box;
    margin: auto;
    a {
      width: 90%;
      text-decoration: underline;
      text-decoration-color: #3a96b8;
    }
    @media (max-width: 991.5px) {
      width: 100%;
    }
  }
`;
